import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira-original-estimate-editable-fix');
	},
};
